import React from 'react'

import styles from './SearchInput.css'

const SearchInput = props => {
  const {
    handleOnChange,
    placeholder = 'Search...',
    value,
    autoFocus,
    onKeyUp,
  } = props

  return (
    <div>
      <input
        onKeyUp={onKeyUp}
        autoFocus={autoFocus}
        onChange={e => handleOnChange(e.target.value)}
        className={styles.searchInput}
        placeholder={placeholder}
        value={value}
      />
    </div>
  )
}

export default SearchInput



// WEBPACK FOOTER //
// ./src/legacy/components/SearchInput/SearchInput.jsx